import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableLeave extends Layout {
    sourceLeaveTransaction: DataSource;
    tableLeave: Table;
}
